export function getXactAnalysisUrl(veriskId: string, isProdEnv: boolean) {
  const prefix = isProdEnv ? 'www' : 'beta'
  return `https://${prefix}.xactanalysis.com/apps/xactanalysis/detail.jsp?mfn=${veriskId}&ddid=${veriskId}&xlink=true#d_assignment`
}
